import React from "react";

export default function EventInfoPopup({ event }) {
   if (!event) return null;

   const asDate = (value) => {
      const parsed = new Date(value);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
   };

   const formatDate = (value) => {
      const parsed = asDate(value);
      if (!parsed) return "Data indisponibila";
      return parsed.toLocaleDateString("ro-RO", {
         weekday: "long",
         day: "numeric",
         month: "long",
         year: "numeric",
      });
   };

   const formatTime = (value) => {
      const parsed = asDate(value);
      if (!parsed) return "--:--";
      return parsed.toLocaleTimeString("ro-RO", {
         hour: "2-digit",
         minute: "2-digit",
      });
   };

   const gearboxValue = String(event?.gearbox || "Nespecificata").trim();
   const gearboxTone = (() => {
      const lower = gearboxValue.toLowerCase();
      if (lower.includes("man")) return "manual";
      if (lower.includes("auto")) return "automatic";
      return "neutral";
   })();

   const dateLabel = formatDate(event.start);
   const timeRange = `${formatTime(event.start)} - ${formatTime(event.end)}`;
   const sectorLabel = String(event?.sector || "Nespecificat").trim();

   return (
      <div className="studentEventPopup">
         <div className="studentEventPopup__hero">
            <h3 className="studentEventPopup__title">Detalii lectie</h3>
         </div>

         <div className="studentEventPopup__content">
            <div className="studentEventPopup__grid">
               <article className="studentEventPopup__card studentEventPopup__card--wide">
                  <span className="studentEventPopup__cardLabel">Interval</span>
                  <strong className="studentEventPopup__cardValue">
                     {timeRange}
                  </strong>
                  <span className="studentEventPopup__cardMeta">{dateLabel}</span>
               </article>

               <article
                  className="studentEventPopup__card"
                  data-tone={gearboxTone}
               >
                  <span className="studentEventPopup__cardLabel">Cutie</span>
                  <strong className="studentEventPopup__cardValue">
                     {gearboxValue}
                  </strong>
                  <span className="studentEventPopup__cardMeta">
                     Configuratia masinii
                  </span>
               </article>

               <article className="studentEventPopup__card">
                  <span className="studentEventPopup__cardLabel">Sector</span>
                  <strong className="studentEventPopup__cardValue">
                     {sectorLabel}
                  </strong>
                  <span className="studentEventPopup__cardMeta">
                     Zona programarii
                  </span>
               </article>
            </div>
         </div>
      </div>
   );
}
